import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Flex, Empty, Spin, Tooltip, Button } from "antd";

import Widget from "@/components/ui/Widget";
import NotificationCard from "@/components/cards/NotificationCard";

import RefreshIcon from "@/icons/RefreshIcon";
import SettingsIcon from "@/icons/SettingsIcon";

import { readNotices, getList as getNotices } from "@/api/notices";

import routes from "@/routes";

const NoticesWidget = () => {
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    fetchData();
    // const intervalId = setInterval(fetchData, 30000); // 30 секунд

    // return () => clearInterval(intervalId); // очистка интервала при размонтировании
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    setPending(true);

    try {
      const { notifications } = await getNotices({
        page: 1,
        perpage: 10,
        sort: "-created_at",
        unread_only: "unread",
      });

      setData(notifications);
    } catch (error) {
      console.log("error", error);
    } finally {
      setPending(false);
    }
  };

  const handleReadNotice = async (uuid) => {
    try {
      await readNotices([uuid]);
      fetchData();
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <Widget
      value="notices"
      label={
        <Link to={routes.notices("inbox")} className="base-link">
          Уведомления
        </Link>
      }
      labelSecond={data.map(({ events }) => events).flat().length || 0}
      isOpen={true}
      extra={
        <Flex align="center">
          <Tooltip title="Настройки уведомлений" zIndex={3000}>
            <Link to={routes.notices("settings")}>
              <Button
                color="default"
                variant="link"
                size="small"
                aria-label="Настройки уведомлений"
                icon={<SettingsIcon style={{ fontSize: 18 }} />}
                onClick={(e) => e.stopPropagation()}
              />
            </Link>
          </Tooltip>
          <Tooltip title="Обновить" zIndex={3000}>
            <Button
              color="default"
              variant="link"
              size="small"
              aria-label="Обновить уведомления"
              icon={<RefreshIcon style={{ fontSize: 18 }} />}
              onClick={(e) => {
                e.stopPropagation();
                fetchData();
              }}
            />
          </Tooltip>
        </Flex>
      }
    >
      {pending ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        <>
          {!data?.length ? (
            <Empty
              image={false}
              description="Нет уведомлений"
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          ) : (
            <Flex
              vertical
              gap={8}
              style={{ paddingBottom: 25, paddingRight: 3 }}
            >
              {/* TODO: убрать потом эту порнографию */}
              {data.map((noticeGroup) =>
                noticeGroup.events.map((notice) => (
                  <NotificationCard
                    key={notice.uuid}
                    data={{
                      ...notice,
                      object: noticeGroup.object,
                      object_type: noticeGroup.object_type,
                      unit: noticeGroup.unit,
                    }}
                    size="small"
                    onClose={() => handleReadNotice(notice.uuid)}
                  />
                )),
              )}
            </Flex>
          )}
        </>
      )}
    </Widget>
  );
};

export default NoticesWidget;
